import {useMemo} from 'react'
import useRouter from 'hooks/useRouter'
import {Box, Card} from '@binance/uikit'
import Tooltip from 'components/Tooltip'
import useMarginBalance from 'hooks/useMarginBalance'
import useUserLoginStatus from 'hooks/useUserLoginStatus'
import tipMsgData from 'assets/tipMsgData'
import Table from './Table'
import {NoData} from './NoData'
import TransferBtn from '../Common/TransferBtn'

const getTitles = i18n => [
  {
    title: i18n['tradeHistory-assetTitle'] || 'Asset',
    key: 'asset',
    direction: 'start',
    width: 80
  },
  {
    title: (
      <Tooltip
        label={i18n['tradeHistory-marginBalance-walletBalanceTitle'] || 'Wallet Balance'}
        tip={i18n['tradeHistory-marginBalance-walletBalanceTip'] || tipMsgData.walletBalance}
      />
    ),
    key: 'walletBalance',
    direction: 'start',
    width: 110
  },
  {
    title: (
      <Tooltip
        label={i18n['tradeHistory-marginBalance-unrealizedPNLTitle'] || 'Unrealized PNL'}
        tip={i18n['tradeHistory-marginBalance-unrealizedPNLTip'] || tipMsgData.unrealizedPnl}
      />
    ),
    key: 'unrealizedPnl',
    direction: 'start',
    width: 110
  },
  {
    title: (
      <Tooltip
        label={
          i18n['tradeHistory-marginBalance-initialMarginRequiredTitle'] || 'Initial Margin Required'
        }
        tip={
          i18n['tradeHistory-marginBalance-initialMarginRequiredTip']
          || tipMsgData.initialMarginRequired
        }
      />
    ),
    key: 'initialMargin',
    direction: 'start',
    width: 100
  },
  {
    title: (
      <Tooltip
        label={i18n['tradeHistory-marginBalance-availableForOrderTitle'] || 'Available for Order'}
        tip={
          i18n['tradeHistory-marginBalance-availableForOrderTip'] || tipMsgData.availableForOrder
        }
      />
    ),
    key: 'availableForOrder',
    direction: 'start',
    width: 110
  },
  {
    title: (
      <Tooltip
        label={
          i18n['tradeHistory-marginBalance-availableForWithdrawTitle'] || 'Available for Withdraw'
        }
        tip={
          i18n['tradeHistory-marginBalance-availableForWithdrawTip']
          || tipMsgData.availableForWithdraw
        }
      />
    ),
    key: 'availableForWithDraw',
    direction: 'end',
    width: 110
  },
  {
    title: '',
    key: 'button',
    width: 110
  }
]

export default function MarginBalcncePane ({i18n}) {
  const router = useRouter()
  const {symbol} = router.query
  const balanceList = useMarginBalance(symbol)
  const isLogin = useUserLoginStatus()
  return useMemo(() => {
    const data = balanceList.map(el => {
      el.button = <TransferBtn i18n={i18n} style={{fontSize: '12px'}} />
      return el
    })
    return isLogin ? (
      <Card width="100%" bg="unset">
        <Box flex={1}>
          <Table
            title={getTitles(i18n)}
            data={data}
            nodata={isLogin ? NoData('margin balance') : null}
            style={{willChange: 'unset'}}
          />
        </Box>
      </Card>
    ) : null
  }, [balanceList, i18n, isLogin])
}
